import _ from 'underscore'

/**
 * 计算分区价格对照表
 */
export const getSectionMap = (seatingChart, sectionPrices) => {
  if (_.isEmpty(seatingChart) || _.isEmpty(sectionPrices)) {
    return {}
  }

  const seats = seatingChart.seats || []
  const map = {}

  _.clone(sectionPrices).forEach((item, index) => {
    item.index = index + 1
    for (let seatItem of seats) {
      if (seatItem.sectionId === item.sectionId) {
        item.sectionName = seatItem.sectionName
        break
      }
    }
    map[item.sectionId] = item
  })
  return map
}

/**
 * 座位价格
 */
export const getSeatPrice = (seat, sectionMap) => {
  const match = sectionMap[seat.sectionId] || {}
  const { price = 0, fee = 0 } = match
  return price + fee
}
